import Vue from "vue";

Vue.filter('currency', GetCurrencyFilter());
Vue.filter('percent', GetPercentFilter());

function GetCurrencyFilter(): any {
	return function (value: any) {
		if (typeof value !== "number") {
			return value;
		}
		var formatter = new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: 'USD',
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		});
		return formatter.format(value).replace(/^(\D+)/, '$1 ');
	}
}

function GetPercentFilter(): any {
	return function (value: any) {
		if (typeof value !== "number") {
			return value;
		}
		var formatter = new Intl.NumberFormat('en-US', {
			style: 'percent',
			minimumFractionDigits: 2
		});
		return formatter.format(value / 100);
	}
}
